<script setup>
import FormElementMixins from '@/mixins/FormElementMixins'
</script>
<template lang="">
    <div>
        <div class="mb-3">
            <label :for="`field${element.type}${index}`" class="form-label" v-if="fieldTitle">{{ fieldTitle }}</label>
            <textarea :data-section="element.section" :rows="element.rows" :cols="element.cols" class="form-control" :id="`field${element.type}${index}`" :placeholder="element.placeholder" :required="element.required" v-model="element.value"></textarea>
        </div>
    </div>
</template>
<script>
export default {
    name: 'FormElementTextarea',
    mixins: [FormElementMixins]
}
</script>
<style lang="">
    
</style>